import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';

import Header from '../Header/Header';
import Navigation from '../Header/Navigation';
import OrderList from './OrderList';
import ActiveOrders from './ActiveOrders';
import OrdersByDate from './ByDate';
import EditOrder from './EditOrder';
import {
  NavOuter,
  NavContainer
} from '../Styles/index';


const linkItems = [
  {
    to: "/orders",
    text: "Order List",
    exact: true
  },
  {
    to: "/orders/active",
    text: "Active Orders"
  },
  {
    to: "/orders/by-date",
    text: "Orders By Date"
  }
];

class Orders extends Component {

  render() {
    return (
      <div>
        <Header/>
        <NavOuter bg={this.props.muiTheme.palette.primary2Color}>
          <NavContainer>
            <Navigation height={'36px'} darker items={linkItems}></Navigation>
          </NavContainer>
        </NavOuter>
        <Switch>
          <Route exact path="/orders" component={OrderList}/>
          <Route path="/orders/edit" component={EditOrder}/>
          <Route path="/orders/active" component={ActiveOrders}/>
          <Route path="/orders/by-date" component={OrdersByDate}/>
        </Switch>
      </div>
    );
  }
}

export default muiThemeable()(Orders);




// WEBPACK FOOTER //
// ./src/components/Orders/index.js